import type { AoiLandCoverCategoryKey } from '@/types/flood.types';

/** Màu ô legend (UI) — đồng bộ với tab Lớp phủ AOI. */
export const LAND_COVER_LEGEND_SWATCH: Record<AoiLandCoverCategoryKey, string> = {
  ricePaddy: '#9ccc7a',
  urbanBuilt: '#94a3b8',
  forest: '#228b22',
  perennialCrop: '#b4a05a',
  surfaceWater: '#38bdf8',
};
